import { useEffect, useState } from 'react';

import {
  GET_TERMINAL_MAPPINGS,
  SWING_CONTRACT_MESSAGES,
} from '../../../constants/FieldNomsSwingContract';
import { HTTPS_STATUS_CODES } from '../../../constants/Common';
import { get } from '../../../services/GenesisApi';
import { SwingContractMapping } from '../../../types/FieldNomsSwingContract.type';
import { sendNotification } from '../../../UI/Notification';

const { FAILED_FETCH_SWING_CONTRACT_MAPPINGS } = SWING_CONTRACT_MESSAGES;

const useGetSwingContractMappings = (isValid: boolean) => {
  const [swingContractMappings, setSwingContractMappings] = useState<
    SwingContractMapping[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const getSwingContractMappings = (valid = true): void => {
    setLoading(true);
    setError(null);

    get(GET_TERMINAL_MAPPINGS(valid))
      .then((res) => {
        if (res.status === HTTPS_STATUS_CODES.SUCCESS) {
          const { data } = res;
          setSwingContractMappings(data);
        }
      })
      .catch((err) => {
        setError(err ?? FAILED_FETCH_SWING_CONTRACT_MAPPINGS);
        sendNotification({
          type: 'error',
          message: err ?? FAILED_FETCH_SWING_CONTRACT_MAPPINGS,
        });
        setSwingContractMappings([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSwingContractMappings(isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid]);

  return { swingContractMappings, loading, error, getSwingContractMappings };
};

export default useGetSwingContractMappings;
